function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 24,
  height: 24,
  fill: "#D9D9D9"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4292_10789)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 19.7135L11.9423 16.1558L12.65 15.4481L15.5 18.2981L21.1885 12.6096L21.8962 13.3173L15.5 19.7135ZM20 10.5H19V6.11536C19 5.96152 18.9359 5.8205 18.8077 5.69228C18.6795 5.56408 18.5385 5.49998 18.3846 5.49998H16V7.73076H8V5.49998H5.61538C5.46154 5.49998 5.32052 5.56408 5.1923 5.69228C5.0641 5.8205 5 5.96152 5 6.11536V18.8846C5 19.0384 5.0641 19.1795 5.1923 19.3077C5.32052 19.4359 5.46154 19.5 5.61538 19.5H11V20.5H5.61538C5.16794 20.5 4.78685 20.3426 4.4721 20.0279C4.15737 19.7131 4 19.332 4 18.8846V6.11536C4 5.66792 4.15737 5.28683 4.4721 4.97208C4.78685 4.65735 5.16794 4.49998 5.61538 4.49998H10.2519C10.3455 4.10895 10.5532 3.78042 10.875 3.51441C11.1968 3.24837 11.5718 3.11536 12 3.11536C12.4359 3.11536 12.8138 3.24837 13.1337 3.51441C13.4535 3.78042 13.6603 4.10895 13.7538 4.49998H18.3846C18.8321 4.49998 19.2132 4.65735 19.5279 4.97208C19.8426 5.28683 20 5.66792 20 6.11536V10.5ZM12 5.73076C12.232 5.73076 12.4247 5.65415 12.5779 5.50093C12.7311 5.34773 12.8077 5.15511 12.8077 4.92306C12.8077 4.69101 12.7311 4.49838 12.5779 4.34518C12.4247 4.19196 12.232 4.11536 12 4.11536C11.768 4.11536 11.5753 4.19196 11.4221 4.34518C11.2689 4.49838 11.1923 4.69101 11.1923 4.92306C11.1923 5.15511 11.2689 5.34773 11.4221 5.50093C11.5753 5.65415 11.768 5.73076 12 5.73076Z",
  fill: "white"
}));

function SvgIconScanComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4292_10789",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _ref), _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScanComplete);
export default __webpack_public_path__ + "static/media/icon-scan-complete.7b636c5d611a633e15456767bd3dc10f.svg";
export { ForwardRef as ReactComponent };